<template>
  <div style="height: 100%">
    <el-header class="outheader">
      <TopHeader :showInspiration="showInspiration"
                 @inspiration="inspiration" />
    </el-header>
    <div style="width:100%; height:60px"></div>
    <div v-if="showInspiration"
         class="inspiration-content-outer">
      <div class="inspiration-content">
        <div class="title">
          <span class="inspText">灵感中心</span>
        </div>
        <div class="sub-title">
          共享魔镜CMI各产品自定义分析规则~助你极速获取市场洞察和产品创新灵感！
        </div>
        <div class="headSearch">
          <social-form @formChange="paramsChange"></social-form>
        </div>
        <div class="table-area"
             v-if="Object.keys(formParams).length > 0">
          <vueDatable ref="projTable"
                      @TotalChanged="handleTotalChange"
                      @CurrentChange="handleCurrentChange"
                      @NameClick="NameClick"
                      :options="options_datable_inspiration"
                      :getDataMethod="dataMethod"> </vueDatable>
          <div>
            <el-dialog width="50%"
                       append-to-body
                       :visible.sync="previewDialog">
              <table>
                <thead>
                  <tr>
                    <th style="min-width: 100px; max-width: 150px; text-align: center">名称</th>
                    <th style="min-width: 200px; text-align: center; max-width: 250px">商品标题规则</th>
                    <th v-if="showAttr"
                        style="min-width: 100px; text-align: center; max-width: 150px">属性</th>
                    <th v-if="showAttr"
                        style="min-width: 200px; text-align: center; max-width: 250px">属性规则</th>
                  </tr>
                </thead>
                <tr v-for="item in priviewData"
                    :key="item.rule_group_id">
                  <td style="padding: 10px">
                    <el-input style="width: 180px"
                              size="small"
                              v-model="item.title_name"
                              placeholder=""></el-input>
                  </td>
                  <td style="padding: 10px">
                    <el-input v-model="item.title_rule"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                  <td v-if="showAttr"
                      style="padding: 10px 10px">
                    <el-input v-model="item.attr_name"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                  <td v-if="showAttr"
                      style="padding: 10px 10px">
                    <el-input v-model="item.attr_rule"
                              placeholder=""
                              size="small"></el-input>
                  </td>
                </tr>
              </table>
            </el-dialog>
          </div>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="currentPage"
                           :page-sizes="[10,50,100]"
                           :page-size.sync="currentSize"
                           :pager-count="7"
                           background
                           layout="total ,sizes, ->, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!showInspiration"
         class="content-outer">
      <div class="content">
        <div class="title">
          <div class="title-text">魔镜CMI平台</div>
        </div>
        <div class="subtitle">
          <div class="subtext">
            <span>整合销售</span>
            <span>、</span>
            <span>评论</span>
            <span>、</span>
            <span>社媒</span>
            <span>三大数据源，助力</span>
            <span>市场研究</span>
            <span>和</span>
            <span>消费者洞察</span>
          </div>
          <div class="subtext">（Consumer & Market Insight， 简称CMI）</div>
        </div>
        <div class="image-box">
          <div class="image-card">
            <div class="cmi-content">
              <div class="text-name">
                <div>
                  <i class="el-icon-data-line icon"></i>
                  <span class="title">魔镜分析+</span>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">淘宝</el-tag>
                <el-tag class="cmi-label">天猫</el-tag>
                <el-tag class="cmi-label">京东</el-tag>
                <el-tag class="cmi-label">抖音</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />平台打通，一键查看主流电商销售表现</p>
                <p><i class="el-icon-circle-check icon" />全量商品数据，把握潜力市场与新兴趋势</p>
                <p><i class="el-icon-circle-check icon" />灵活定义细分市场，研判市场进入可行性</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('fenxiplus')">开始使用</el-button>
            </div>
          </div>
          <div class="image-card">
            <div class="cmi-content">
              <div class="text-name">
                <div>
                  <i class="el-icon-edit-outline icon"></i>
                  <span class="title">电商聆听</span>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="linear-text">
                <span class="deepSeek-text">接入DeepSeek</span>
                <img class="icon-xStar" src="../assets/star.png">
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">天猫</el-tag>
                <el-tag class="cmi-label">京东</el-tag>
                <el-tag class="cmi-label">抖音</el-tag>
                <el-tag class="cmi-label">Amazon</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />AI驱动，高效精准的消费者评论分析</p>
                <p><i class="el-icon-circle-check icon" />品类/品牌/产品口碑分析，捕捉消费者痛点</p>
                <p><i class="el-icon-circle-check icon" />从消费者场景/需求出发挖掘产品创新机会</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('comment')">开始使用</el-button>
            </div>
          </div>
          <div class="image-card">
            <div class="cmi-content">
              <div class="text-name">
                <div>
                  <img class="image"
                       src="../assets/volume.png">
                  <span class="title">社交聆听</span>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="linear-text">
                <span class="deepSeek-text">接入DeepSeek</span>
                <img class="icon-xStar" src="../assets/star.png">
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">小红书</el-tag>
                <el-tag class="cmi-label">抖音</el-tag>
                <el-tag class="cmi-label">微博</el-tag>
                <el-tag class="cmi-label">得物</el-tag>
                <el-tag class="cmi-label">B站</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />AI提取人货场标签，从社媒数据分析产品趋势</p>
                <p><i class="el-icon-circle-check icon" />品类/场景/人群分析，发现消费者生活方式</p>
                <p><i class="el-icon-circle-check icon" />话题/代言人/IP分析，优化品牌营销决策</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('sociales')">开始使用</el-button>
            </div>
          </div>
        </div>
        <div class="image-box"
             :style="isPartner ? 'justify-content: center' : ''">
          <div class="image-card"
               :style="isPartner ? 'margin-right: 23px' : ''">
            <div class="cmi-content">
              <div class="text-name">
                <div>
                  <img class="image"
                       src="../assets/oversea.png">
                  <span class="title">海外电商Oversea</span>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">Amazon</el-tag>
                <el-tag class="cmi-label">Shopee</el-tag>
                <el-tag class="cmi-label">Lazada</el-tag>
                <el-tag class="cmi-label">TikTok</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />欧美/日本/中东/东南亚全品类电商数据</p>
                <p><i class="el-icon-circle-check icon" />灵活筛选，验证海外细分市场潜力</p>
                <p><i class="el-icon-circle-check icon" />立足魔镜品牌服务经验，助力出海决策</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('oversea')">开始使用</el-button>
            </div>
          </div>
          <div class="image-card">
            <div class="cmi-content">
              <div class="text-name">
                <div>
                  <img class="image"
                       src="../assets/data.png">
                  <span class="title">增长雷达</span>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">国内电商</el-tag>
                <el-tag class="cmi-label">国内社媒</el-tag>
                <el-tag class="cmi-label">海外电商</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />海内外高增长概念/品类/品牌一站式查看</p>
                <p><i class="el-icon-circle-check icon" />海量蓝海概念，无穷产品创新灵感</p>
                <p><i class="el-icon-circle-check icon" />社媒高增概念，热点话题一网打尽</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('chance')">开始使用</el-button>
            </div>
          </div>
          <div class="image-card"
               v-if="!isPartner">
            <div class="cmi-content ai-pro">
              <div class="deepSeek-card">
                <div class="deepSeek-title">镜界AI</div>
                <div class="deepSeek-triangle"></div>
              </div>
              <div class="label-box">
                <el-tag class="cmi-label">DeepSeek-R1</el-tag>
                <el-tag class="cmi-label">极速市场调研</el-tag>
              </div>
              <div class="text-explain">
                <p><i class="el-icon-circle-check icon" />会深度思考的消费品商业分析Agent</p>
                <p><i class="el-icon-circle-check icon" />集成CMI产品数据，一键分析市场</p>
                <p><i class="el-icon-circle-check icon" />桌面调研+市场数据，全面支撑结论</p>
              </div>
              <!-- 开始使用按钮 -->
              <el-button type="primary"
                         class="get-start"
                         @click="buttonClickHandler('aipro')">开始使用</el-button>
            </div>
          </div>
        </div>
        <div>
          <el-dialog width="30%"
                     append-to-body
                     :visible.sync="showDialog">
            <span style="color:black;">
              该产品未合作，您可以免费试用
              <i style="color:crimson; font-size: 30px; font-style: normal;">3</i>
              天，请问您是否要现在开始试用
            </span>
            <span slot="footer"
                  class="dialog-footer">
              <el-button type="primary"
                         @click="buttonClick('privilege')">是</el-button>
              <el-button @click="showDialog = false">否</el-button>
            </span>
          </el-dialog>
        </div>
        <div>
          <el-dialog width="30%"
                     append-to-body
                     :visible.sync="showDialog2">
            <span style="color:black;">
              试用时间到期，如需再开通，请联系对应销售申请
            </span>
            <span slot="footer"
                  class="dialog-footer">
              <el-button type="primary"
                         @click="showDialog2 = false">是</el-button>
              <el-button @click="showDialog2 = false">否</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <el-footer style="padding: 0;">
      <div class="footer">
        <div class="foot-text">数据由公开页面采集并汇总处理，数据口径和平台及其他机构有所不同，仅供参考，如有差异请以平台官方发布数据为准</div>
        <div class="foot-number">
          <span> ©2025 北京淘幂科技有限公司 </span>
          <a href="https://beian.miit.gov.cn/"
             target="_blank">京ICP备15061734号-4</a> |
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037832"
             target="_blank">
            <img src="https://static.mktindex.com/common/images/gonganlogo.png"
                 style="vertical-align: sub; width: 15px">
            京公网安备 11010502037832号
          </a>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { getUserInfo, getPrivilege, createPrivilege } from '@/api/user'
import TopHeader from '@/components/topHeader.vue'
import { getCustomList, getCopyCustom } from '@/api/inspiration'
import { VueDatatable as vueDatable } from 'common'
import tdComputePlats from '@/components/InspirationTd/tdComputePlats.vue'
import tdTimeSubstring from '@/components/InspirationTd/tdTimeSubstring.vue'
import tdPreviewCustom from '@/components/InspirationTd/tdPreviewCustom.vue'
import SocialForm from '@/components/SocialForm.vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  components: {
    TopHeader,
    vueDatable,
    SocialForm,
  },
  data() {
    return {
      login_url:
        'https://mjlogin.mktindex.com/please_login?service=' +
        window.location.origin +
        '/login&redirect_url=' +
        encodeURIComponent(window.location.href),
      logout_url:
        '/mj_logout?redirect_url=' + encodeURIComponent(window.location.href),
      showDialog: false,
      showDialog2: false,
      btnType: '',
      showInspiration: false,
      total: 0,
      dataMethod: getCustomList,
      currentPage: 1,
      currentSize: 10,
      formParams: {},
      previewDialog: false,
      priviewData: [],
      showAttr: false,
      isPartner: true,
    }
  },
  computed: {
    tableParam() {
      return {
        ...this.formParams,
        page: this.currentPage,
        page_size: this.currentSize,
      }
    },
    options_datable_inspiration() {
      return {
        selection: undefined,
        HeaderSettings: false,
        Pagination: false,
        hasPassData: false,
        query: { limit: 10 },
        columns: [
          {
            title: this.$t('inspTh.analyze_name'),
            field: 'analyze_name',
            label: this.$t('inspTh.analyze_name'),
            tdStyle: { minWidth: '200px' },
          },
          {
            title: this.$t('inspTh.product_name'),
            field: 'product_name',
            label: this.$t('inspTh.product_name'),
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.plat'),
            field: 'data',
            label: this.$t('inspTh.plat'),
            tdComp: tdComputePlats,
            tdStyle: { minWidth: '400px' },
          },
          {
            title: this.$t('inspTh.publish_user'),
            field: 'publish_user',
            label: this.$t('inspTh.publish_user'),
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.publish_time'),
            field: 'publish_time',
            label: this.$t('inspTh.publish_time'),
            sortable: true,
            tdComp: tdTimeSubstring,
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.share_count'),
            field: 'share_count',
            label: this.$t('inspTh.share_count'),
            sortable: true,
            tdStyle: { minWidth: '100px' },
          },
          {
            title: this.$t('inspTh.operation'),
            field: 'analyze_rules',
            label: this.$t('inspTh.operation'),
            tdComp: tdPreviewCustom,
            tdStyle: { minWidth: '100px' },
          },
        ],
        params: this.tableParam,
        _xprops: {},
      }
    },
  },
  methods: {
    buttonClickHandler(button) {
      this.btnType = button
      let msg = '该功能尚未合作，如有需求请联系项目负责人！'
      getPrivilege({
            product: button,
          }).then((res) => {
            if(res.status == 'ok'){
              const pri = res.result.has_pri
              const test = res.result.is_allow_test
              const url = res.result.url
              if (pri == true) {
                window.open(url, '_blank')
              } else if (test == true) {
                this.showDialog = true
              } else {
                this.showDialog2 = true
              }
            }else{
              this.$message.error(e.error_msg)
            }
          })
          .catch((e) => {
            this.$message.error(msg)
          })
    },
    
    buttonClick() {
      createPrivilege({
        product: this.btnType,
      }).then((res) => {
        const url = res.result.url
        window.open(url, '_blank')
      })
    },
    inspiration() {
      this.showInspiration = !this.showInspiration
      this.$router.push({
        query: {
          showInspiration: this.showInspiration,
        },
      })
    },
    handleSizeChange(val) {
      this.currentSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleTotalChange(val) {
      this.total = val
    },
    paramsChange(obj) {
      let { product, plat, cat_name, q, custom_typ } = obj
      this.formParams = { product, plat, cat_name, q, custom_typ }
    },
    NameClick(data) {
      if (data) {
        this.previewDialog = data.previewDialog
        this.priviewData = data.priviewData
        if (this.priviewData[0].attr_title_rel) {
          this.showAttr = true
        } else {
          this.showAttr = false
        }
      }
    },
  },
  async created() {
    const browserFinger = localStorage.getItem('browserFinger')
    if (!browserFinger) {
      const fpPromise = FingerprintJS.load()
      const fp = await fpPromise
      const result = await fp.get()
      localStorage.setItem('browserFinger', result.visitorId)
    }
    getUserInfo().then((res) => {
      this.isPartner = res.result.is_partner
      const usertype = res.result.usertype
      if (usertype == 'logged_out') {
        window.location.href = this.login_url
      } else {
        return
      }
    })
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        if (newVal.showInspiration == 'true') {
          this.showInspiration = true
        }
      },
    },
  },
}
</script>

<style lang="less">
.msgBtn {
  background-color: #3a63f3 !important;
  border-color: #3a63f3 !important;
}
p {
  font-size: 14px;
}
.outheader {
  position: absolute;
  z-index: 2000;
  width: 100%;
  text-align: right;
  font-size: 12px;
  background-color: #060a32;
  height: 60px !important;
  border-radius: 0 0 4px 4px;
  padding: 0 20px;
  .header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .header-left {
      color: #fff;
      .el-popover {
        position: absolute;
        background: none;
        min-width: 150px;
        border-radius: 4px;
        border: 0px;
        padding: 0px;
        z-index: 2000;
        color: #fff;
        line-height: 1.4;
        text-align: justify;
        font-size: 14px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        word-break: break-all;
        top: 20px;
        left: 200px;
      }
      .logo {
        .fl {
          float: left;
          .image {
            height: 35px;
            margin-right: 12px;
          }
          .logo-title {
            font-size: 16px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: 700;
            color: #fff;
            line-height: 20px;
            margin-top: 3px;
          }
          .logo-text {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #fff;
            transform: scale(0.7);
            text-align: center;
            line-height: 10px;
          }
        }
      }
    }
    .header-right {
      .headText {
        color: #ffffff;
      }
      .head-text {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #fff;
      }
    }
  }
}
.content-outer {
  position: relative;
  height: calc(100% - 140px);
  overflow-y: auto;
  .content {
    width: 100%;
    min-width: 1200px;
    .title {
      width: 1200px;
      margin: 70px auto 0px auto;
      .title-text {
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        line-height: 30px;
      }
    }
    .subtitle {
      width: 1200px;
      margin: 20px auto 50px auto;
      .subtext {
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
    }
    .image-box {
      display: flex;
      justify-content: space-evenly;
      width: 1200px;
      margin: 0px auto 46px auto;
      .image-card {
        position: relative;
        width: 370px;
        height: 220px;
        box-shadow: 0px 2px 9px 7px rgba(0, 0, 10, 0.03);
        .text-name {
          position: absolute;
          background: linear-gradient(180deg, #9fdbff 0%, #4c84ff 100%);
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          padding: 6px 12px;
          top: -10px;
          left: 35px;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          .triangle {
            position: absolute;
            width: 0;
            height: 0;
            border: 5px solid;
            border-color: transparent transparent #5084fc #5084fc;
            top: 0px;
            right: -9px;
          }
          .icon {
            font-size: 24px;
            vertical-align: middle;
            margin-right: 5px;
          }
          .image {
            width: 24px;
            filter: invert(100%);
            margin-right: 5px;
          }
          .title {
            height: 24px;
            line-height: 24px;
          }
        }
        .deepSeek-card {
          position: absolute;
          background: linear-gradient(90deg, #F0F3FF 0%, #FFFFFF 50.21%, #ECF5FF 100%);
          box-shadow: 0px 2px 12px 0px #60636D3D;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          padding: 6px 12px;
          top: -10px;
          left: 35px;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          .deepSeek-title {
            height: 24px;
            line-height: 24px;
            background: linear-gradient(90deg, #2B6FFE 0%, #FF9187 100%);
            background-clip: text;
            color: transparent;
            font-weight: bold;
          }
          .deepSeek-triangle {
            position: absolute;
            width: 0;
            height: 0;
            border: 5px solid;
            border-color: transparent transparent #DAE1FD #DAE1FD;
            top: 0px;
            right: -9px;
          }
        }
        .text-explain {
          text-align: left;
          font-size: 13px;
          font-weight: 400;
          color: #616161;
          margin: 10px 0px 10px 35px;
          p {
            height: 24px;
            font-size: 13px;
            letter-spacing: 1px;
            line-height: 24px;
            margin-bottom: 0;
          }
          .icon {
            vertical-align: middle;
            color: #6488fa;
            margin-right: 5px;
          }
        }
        .cmi-content {
          width: 100%;
          height: 100%;
          background-color: #ffffff;
          border: 0px #f7f9ff;
          padding: 12px 0px;
          .get-start {
            background-color: #6888ff;
            border-color: #6888ff;
            padding: 6px 10px;
            margin-left: 35px;
          }
          .linear-text {
            position: absolute;
            background: linear-gradient(90deg, #2B6FFE 0%, #FF9187 100%);
            background-clip: text;
            color: transparent;
            font-weight: bold;
            top: 10px;
            right: 15px;
            .deepSeek-text {
              vertical-align: middle;
              margin-right: 6px;
            }
            .icon-xStar {
              height: 15px;
            }
          }
          .label-box {
            margin-top: 35px;
            margin-left: 35px;
            .cmi-label {
              height: 20px;
              background-color: #dae1fd;
              border-color: #dae1fd;
              color: #2b6ffe;
              font-weight: bold;
              line-height: 20px;
              padding: 0 10px;
              margin-right: 10px;
            }
          }
        }
        .ai-pro {
          background: linear-gradient(180deg, #FFFFFF 0%, #E8EEFF 100%);
          box-shadow: 0px 4px 20px 0px #0000001A;
        }
      }
    }
    .el-dialog {
      .el-dialog__body {
        text-align: center;
        padding: 30px 0px;
      }
      .dialog-footer {
        display: flex;
        justify-content: space-evenly;
        .el-button--primary {
          color: #ffffff;
          background-color: crimson;
          border-color: crimson;
          margin-right: 70px;
        }
        .el-button {
          width: 70px;
          height: 40px;
        }
      }
    }
  }
}
.inspiration-content-outer {
  position: relative;
  width: 100%;
  height: calc(100% - 140px);
  overflow-y: auto;
  .inspiration-content {
    background-color: #ffffff;
    margin: 20px 20px 120px 20px;
    padding: 10px 20px;
    .title {
      display: flex;
      align-items: center;
      .inspText {
        font-size: 18px;
        margin: 10px 0px;
      }
    }
    .sub-title {
      margin-top: 20px;
    }
    .headSearch {
      background: #f3f4f6;
      border-radius: 4px;
      padding: 12px;
      margin-top: 20px;
    }
    .table-area {
      width: 100%;
      max-height: 600px;
      overflow: auto;
      margin-top: 20px;
      .table-bordered {
        border: none;
      }
      thead {
        background: #ffffff;
        th {
          color: #000;
          border: none;
          padding: 8px 2px;
        }
      }
      tbody {
        background: #ffffff;
        td {
          vertical-align: inherit;
          background: #ffffff;
          border: none;
          padding: 0px;
        }
      }
      .pagination {
        position: relative;
        width: 100%;
      }
    }
    .el-button {
      color: #3a63f3;
    }
  }
}
.footer {
  position: fixed;
  z-index: 2000;
  width: 100%;
  color: #7d8a9b;
  background-color: #2c2f33;
  height: 80px !important;
  padding: 15px 20px;
  bottom: 0;
  .foot-text {
    text-align: center;
  }
  .foot-number {
    text-align: center;
    padding-top: 10px;
  }
}
</style>